<template>
  <div class="">
    <!-- MOBILE VERTICAL DESIGN NUEVO -->
    <div class="block sm:hidden">
      
      <div v-if="clasesMostrar.length" class="space-y-3">
        <div v-for="(clase, index) in clasesMostrar" :key="clase.id || index"
          :class="[
            'rounded-xl shadow p-4 flex flex-col gap-2 relative',
            claseComenzo(clase.fecha) ? 'bg-green-50' : 'bg-white'
          ]">
          <div class="flex flex-row justify-between items-start">
            <div class="flex flex-col gap-1 flex-1">
              <div class="text-[11px] font-bold uppercase text-gray-700 font-inter tracking-wide mb-1">
                {{ esTallerExcel ? clase.orden : numeroAOrdinal(index) }}
              </div>
              <div class="font-inter font-bold text-[16px] leading-[1.1] mb-1 text-black">
                {{ esTallerExcel ? clase.subtitulo : clase.subtitulo }}
              </div>
            </div>
            <div class="ml-2 w-20 h-14 relative flex-shrink-0 flex items-center justify-center">
              <div class="w-full h-full rounded-md border border-gray-200 bg-center bg-cover relative flex items-center justify-center overflow-hidden">
                <img
                  :src="obtenerThumbnail(clase)"
                  :alt="esTallerExcel ? clase.subtitulo : clase.titulo"
                  class="w-full h-full object-cover rounded-md"
                  loading="lazy"
                  :style="{
                    filter: !claseComenzo(clase.fecha) ? 'grayscale(1)' : 'none'
                  }"
                />
                <div class="absolute left-1/2 top-1/2 z-10" style="transform: translate(-50%, -50%);">
                  <template v-if="clase.youtubeUrl">
                    <a :href="clase.youtubeUrl" target="_blank" rel="noopener noreferrer">
                      <img
                        :src="claseComenzo(clase.fecha) ? iconoYoutube : iconoCampana"
                        :alt="claseComenzo(clase.fecha) ? 'Ver en YouTube' : 'Agendar clase'"
                        class="w-7 h-7"
                        loading="lazy"
                      />
                    </a>
                  </template>
                  <template v-else>
                    <img
                      :src="claseComenzo(clase.fecha) ? iconoYoutube : iconoCampana"
                      :alt="claseComenzo(clase.fecha) ? 'Ver en YouTube' : 'Agendar clase'"
                      class="w-7 h-7"
                      loading="lazy"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-if="esTallerExcel && clase.descripcion" class="text-[13px] text-gray-700 font-inter mb-1">
            {{ clase.descripcion }}
          </div>
          <div v-else-if="clase.descripcion" class="text-[13px] text-gray-700 font-inter mb-1">
            {{ clase.descripcion }}
          </div>
          <div class="flex items-center gap-2 mt-2">
            <svg xmlns="http://www.w3.org/2000/svg" 
              :class="[
                'h-5 w-5 flex-shrink-0',
                claseComenzo(clase.fecha) ? 'text-green-800' : 'text-black'
              ]" 
              fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span :class="[
              'font-inter font-bold text-[13px] leading-[1.75] uppercase',
              claseComenzo(clase.fecha) ? 'text-green-800' : 'text-black'
            ]">
              {{ (() => {
                const resultado = formatearFechaClase(clase.fecha);
                console.log('🎨 RENDERIZANDO FECHA:', {
                  claseId: clase.id,
                  claseFecha: clase.fecha,
                  resultado: resultado
                });
                return resultado.fecha + (!esVistaDocente ? ` - ${resultado.hora}` : '');
              })() }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-8 px-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-10 w-10 text-gray-400 mb-3" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <h2 class="text-2xl font-bold text-gray-900 mb-2">{{ mensajeProximamente.titulo }}</h2>
        <p class="text-sm text-gray-600 max-w-md mx-auto">
          {{ mensajeProximamente.descripcion }}
        </p>
      </div>
    </div>
    <!-- DESKTOP DESIGN -->
    <div class="hidden sm:block">
      <template v-if="clasesMostrar.length">
        <!-- Encabezado con título y barra de progreso -->
        <div class="flex items-center justify-between mb-6">
          <div class="font-extrabold font-sans leading-tight text-2xl">
            {{ props.tituloClases || `Agendate las ${clasesMostrar.length} clases en vivo` }}
          </div>
          <div class="flex items-center gap-2 min-w-[160px]">
            <span class="text-xs text-black font-semibold font-sans uppercase">PROGRESO</span>
            <div class="w-28 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div class="h-2 bg-blue-500 rounded-full" :style="{ width: progreso + '%' }"></div>
            </div>
            <span class="text-xs text-blue-600 font-bold font-sans">{{ progreso }}%</span>
          </div>
        </div>
        <!-- Tarjetas de clases -->
        <div class="flex flex-col gap-4">
          <div
            v-for="(clase, index) in clasesMostrar"
            :key="clase.id || index"
            :class="[
              'flex flex-row items-stretch rounded-xl p-4 gap-6 transition',
              claseComenzo(clase.fecha) ? 'bg-green-50' : 'bg-gray-100 opacity-80',
              'hover:shadow-lg'
            ]"
          >
            <!-- Info principal -->
            <div class="flex-1 flex flex-col justify-between">
              <div class="flex flex-col gap-1 mb-2">
                <div class="text-xs font-bold uppercase tracking-wide mb-1 text-black">
                  {{ esTallerExcel ? clase.orden : numeroAOrdinal(index) }}
                </div>
                <div class="font-inter font-bold text-[16px] leading-[1] mb-1 text-black">
                  {{ esTallerExcel ? clase.subtitulo : clase.subtitulo }}
                </div>
                <div v-if="esTallerExcel" class="text-base text-gray-700 mb-2" style="font-family: Inter; font-weight: 400; font-size: 14px; line-height: 130%; letter-spacing: 0%;">
                  {{ clase.descripcion }}
                </div>
                <div v-else-if="clase.descripcion" class="text-base text-gray-700 mb-2" style="font-family: Inter; font-weight: 400; font-size: 14px; line-height: 130%; letter-spacing: 0%;">
                  {{ clase.descripcion }}
                </div>
              </div>
              <div class="flex items-center gap-2 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" 
                  :class="[
                    'h-5 w-5 flex-shrink-0',
                    claseComenzo(clase.fecha) ? 'text-green-800' : 'text-black'
                  ]" 
                  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span :class="[
                  'font-inter font-bold text-[13px] leading-[1.75] uppercase',
                  claseComenzo(clase.fecha) ? 'text-green-800' : 'text-black'
                ]">
                  {{ (() => {
                    const resultado = formatearFechaClase(clase.fecha);
                    console.log('🎨 RENDERIZANDO FECHA:', {
                      claseId: clase.id,
                      claseFecha: clase.fecha,
                      resultado: resultado
                    });
                    return resultado.fecha + (!esVistaDocente ? ` - ${resultado.hora}` : '');
                  })() }}
                </span>
              </div>
            </div>
            <!-- Imagen más grande y protagonista -->
            <div class="flex-shrink-0 flex items-center justify-center">
              <div
                class="w-64 h-36 rounded-md border border-gray-300 shadow-sm bg-center bg-cover relative flex items-center justify-center">
                <!-- Fondo con filtro -->
                <div
                  class="absolute inset-0 rounded-md bg-center bg-cover"
                  :style="{
                    backgroundImage: clase.thumbnail ? `url('${clase.thumbnail}')` : 'none',
                    filter: clase.thumbnail && !claseComenzo(clase.fecha) ? 'grayscale(1)' : 'none',
                    zIndex: 1
                  }"
                ></div>
                <!-- Ícono SIEMPRE a color -->
                <div class="absolute left-1/2 top-1/2 z-10" style="transform: translate(-50%, -50%);">
                  <template v-if="clase.youtubeUrl">
                    <a :href="clase.youtubeUrl" target="_blank" rel="noopener noreferrer">
                      <img
                        :src="claseComenzo(clase.fecha) ? iconoYoutube : iconoCampana"
                        :alt="claseComenzo(clase.fecha) ? 'Ver en YouTube' : 'Agendar clase'"
                        class="w-12 h-12"
                        loading="lazy"
                      />
                    </a>
                  </template>
                  <template v-else>
                    <img
                      :src="claseComenzo(clase.fecha) ? iconoYoutube : iconoCampana"
                      :alt="claseComenzo(clase.fecha) ? 'Ver en YouTube' : 'Agendar clase'"
                      class="w-12 h-12"
                      loading="lazy"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- Mensaje cuando no hay clases -->
      <template v-else>
        <div class="text-center py-8 sm:py-12 px-3 sm:px-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-10 w-10 sm:h-12 sm:w-12 text-gray-400 mb-3 sm:mb-4"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <h2 class="text-2xl font-bold text-gray-900 mb-2">{{ mensajeProximamente.titulo }}</h2>
          <p class="text-sm sm:text-base text-gray-600 max-w-md mx-auto">
            {{ mensajeProximamente.descripcion }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, shallowRef } from 'vue';
import { useTalleresStore } from '@/stores/talleres';
import moment from 'moment';
import 'moment-timezone';
import iconoYoutube from '@/assets/images/Talleres/youtube.png';
import iconoCampana from '@/assets/images/Talleres/campana.png';
import axios from 'axios';
import Papa from 'papaparse';
import { useRoute } from 'vue-router';
import { getExcelUrl, getTallerSectionConfig, talleresConfig } from '@/utils/talleresExcel';

const talleresStore = useTalleresStore();
const route = useRoute();

const props = defineProps({
  taller: {
    type: Object,
    required: false
  },
  horaInicio: {
    type: [String, Number],
    required: false
  },
  duracionClases: {
    type: [String, Number],
    required: false
  },
  tituloClases: {
    type: String,
    default: ''
  },
  clases: {
    type: Array,
    default: () => []
  },
  mostrarProgreso: {
    type: Boolean,
    default: true
  }
});

// Cache para memoización
const memoizedValues = new Map();

// Función para memoizar valores costosos
const memoize = (key, fn, dependencies = []) => {
  const cacheKey = `${key}_${dependencies.join('_')}`;
  if (!memoizedValues.has(cacheKey)) {
    memoizedValues.set(cacheKey, fn());
  }
  return memoizedValues.get(cacheKey);
};

// Computed properties optimizadas
const tallerActual = computed(() => {
  return props.taller || talleresStore.tallerActual;
});

// Valores por defecto
const titulo = 'Agendate las clases en vivo';
const docente = computed(() => {
  const nombreTaller = tallerActual.value?.titulo || '';
  const match = nombreTaller.match(/- ([^-]+)$/);
  return match ? match[1].trim() : 'Docente';
});
const subtitulo = 'Ya están programadas en YouTube:';

// Mensaje personalizable para cuando no hay fechas
const mensajeProximamente = {
  titulo: 'Próximamente',
  descripcion: 'Te notificaremos cuando estén disponibles para que puedas agendarlas.'
};

// URL base para las imágenes del CDN por defecto
const CDN_URL = 'https://cdn.escuelaorsai.ar/agenda-clase.jpg';

// Computed properties optimizadas para el path del taller
const tallerPath = computed(() => {
  const path = route.path;
  const match = path.match(/\/virtuales\/[^/]+\/([^/]+\/[^/]+)/);
  return match ? match[1] : '';
});

// Computed para saber si el taller está en talleresExcel
const esTallerExcel = computed(() => {
  const [taller, seccion] = tallerPath.value.split('/');
  const hasConfig = !!talleresConfig[taller]?.[seccion];
  
  console.log('🔍 esTallerExcel computed:', {
    tallerPath: tallerPath.value,
    taller: taller,
    seccion: seccion,
    hasConfig: hasConfig,
    talleresConfig: talleresConfig[taller],
    resultado: hasConfig
  });
  
  return hasConfig;
});

// Computed para detectar si estamos en la vista de docente
const esVistaDocente = computed(() => {
  return route.path.includes('/docentes/') || route.path.includes('/inscripciones/');
});

// Ref para almacenar los datos del Excel con lazy loading
const datosExcelAgenda = shallowRef([]);

// Computed properties optimizadas para el estado del taller
const estadoTaller = computed(() => {
  if (!tallerActual.value?.agenda?.length) return 'sin_agenda';
  
  return memoize('estadoTaller', () => {
    const clasesOrdenadas = [...tallerActual.value.agenda].sort((a, b) =>
      new Date(a.fecha) - new Date(b.fecha)
    );

    const primeraClase = new Date(clasesOrdenadas[0].fecha);
    const ultimaClase = new Date(clasesOrdenadas[clasesOrdenadas.length - 1].fecha);
    const ahora = new Date();

    if (ahora < primeraClase) return 'pendiente';
    if (ahora > ultimaClase) return 'finalizado';
    return 'en_curso';
  }, [tallerActual.value?.agenda?.length, tallerActual.value?.agenda?.[0]?.fecha]);
});

// Computed properties optimizadas para el progreso
const progreso = computed(() => {
  if (!clasesMostrar.value.length) return 0;

  return memoize('progreso', () => {
    const clasesCompletadas = clasesMostrar.value.filter(clase => 
      claseComenzo(clase.fecha)
    ).length;

    const totalClases = clasesMostrar.value.length;
    const porcentaje = Math.round((clasesCompletadas / totalClases) * 100);

    console.log('📊 Progreso calculado:', {
      origenAgenda: origenAgenda.value,
      totalClases: totalClases,
      clasesCompletadas: clasesCompletadas,
      porcentaje: porcentaje
    });

    return Math.min(100, Math.max(0, porcentaje));
  }, [clasesMostrar.value.length, clasesMostrar.value.map(c => c.fecha).join(','), origenAgenda.value]);
});

// Helper optimizado para obtener thumbnail
const obtenerThumbnail = (clase) => {
  return clase.thumbnail || CDN_URL;
};

// Función para detectar el origen de la agenda
const detectarOrigenAgenda = (clases) => {
  if (!clases || clases.length === 0) {
    console.log('🔍 detectarOrigenAgenda: No hay clases');
    return 'vacio';
  }

  // Tomar la primera clase como muestra
  const primeraClase = clases[0];
  console.log('🔍 detectarOrigenAgenda - Primera clase:', {
    id: primeraClase.id,
    fecha: primeraClase.fecha,
    titulo: primeraClase.titulo,
    subtitulo: primeraClase.subtitulo
  });

  // Detectar por formato de fecha
  if (primeraClase.fecha && primeraClase.fecha.includes('T') && primeraClase.fecha.includes('Z')) {
    console.log('✅ Origen detectado: STRAPI (formato ISO UTC)');
    return 'strapi';
  }

  if (primeraClase.fecha && (primeraClase.fecha.includes('DE') || primeraClase.fecha.includes('de'))) {
    console.log('✅ Origen detectado: EXCEL (formato español)');
    return 'excel';
  }

  // Detectar por estructura de datos
  if (primeraClase.youtubeUrl && primeraClase.thumbnail && primeraClase.descripcion) {
    console.log('✅ Origen detectado: STRAPI (estructura completa)');
    return 'strapi';
  }

  if (primeraClase.NOMBRE_CLASE || primeraClase.FECHA_HORA_CLASE) {
    console.log('✅ Origen detectado: EXCEL (campos específicos)');
    return 'excel';
  }

  console.log('❓ Origen no detectado, asumiendo STRAPI');
  return 'strapi';
};

// Computed para el origen de la agenda
const origenAgenda = computed(() => {
  let clasesBase = [];

  // Si se pasan clases como props, usarlas directamente
  if (props.clases && props.clases.length > 0) {
    clasesBase = props.clases;
  } else {
    clasesBase = tallerActual.value?.agenda || [];
  }

  return detectarOrigenAgenda(clasesBase);
});

// Helper optimizado para verificar si una fecha ya pasó
const claseComenzo = (fecha) => {
  if (!fecha) return false;
  
  return memoize(`claseComenzo_${fecha}`, () => {
    const ahora = new Date();
    let fechaClase;
    
    // Si la agenda viene de Excel
    if (origenAgenda.value === 'excel') {
      console.log('📊 claseComenzo: Procesando fecha de Excel');
      const fechaLimpia = fecha.toLowerCase().replace(/^[^,]+, /, '');
      fechaClase = moment(fechaLimpia, 'D [de] MMMM [de] YYYY', 'es');
      
      if (datosExcelAgenda.value?.[0]?.HORA) {
        const [horas, minutos] = datosExcelAgenda.value[0].HORA.split(':');
        fechaClase.hours(parseInt(horas, 10));
        fechaClase.minutes(parseInt(minutos, 10));
      }
    } else {
      // Si la agenda viene de Strapi
      console.log('📊 claseComenzo: Procesando fecha de Strapi');
      fechaClase = moment.tz(fecha, 'UTC').tz('America/Argentina/Buenos_Aires');
    }
    
    const resultado = fechaClase < ahora;
    console.log('📊 claseComenzo resultado:', {
      fecha: fecha,
      fechaClase: fechaClase.format(),
      ahora: ahora.toISOString(),
      resultado: resultado
    });
    
    return resultado;
  }, [fecha, origenAgenda.value, datosExcelAgenda.value?.[0]?.HORA]);
};

// Función optimizada para ordinales en español
const numeroAOrdinal = (n) => {
  const ordinales = [
    'Primera', 'Segunda', 'Tercera', 'Cuarta', 'Quinta', 'Sexta', 'Séptima',
    'Octava', 'Novena', 'Décima', 'Undécima', 'Duodécima', 'Decimotercera',
    'Decimocuarta', 'Decimoquinta'
  ];
  return ordinales[n] || `${n + 1}ª`;
};

// Computed properties optimizadas para las clases a mostrar
const clasesMostrar = computed(() => {
  let clasesBase = [];

  // Si se pasan clases como props, usarlas directamente
  if (props.clases && props.clases.length > 0) {
    clasesBase = props.clases;
  } else {
    clasesBase = tallerActual.value?.agenda || [];
  }

  // Log temporal para depuración
  console.log('AGENDA RECIBIDA EN AGENDADINAMICA:', clasesBase.map(c => ({ id: c.id, fecha: c.fecha, titulo: c.titulo })));

  // Solo mapear fechaFormateada si es taller Excel, no para Strapi
  if (esTallerExcel.value) {
    return clasesBase.map((clase, index) => ({
      ...clase,
      fechaFormateada: formatearFechaClase(clase.fecha),
      orden: clase.orden || index + 1,
      id: clase.id || `clase-${index}`
    }));
  } else {
    // Para Strapi, mantener las clases sin procesar fecha
    return clasesBase.map((clase, index) => ({
      ...clase,
      orden: clase.orden || index + 1,
      id: clase.id || `clase-${index}`
    }));
  }
});

// Función optimizada para obtener datos del Excel
const fetchGoogleSheetAgenda = async () => {
  try {
    const [taller, seccion] = tallerPath.value.split('/');
    const excelUrl = getExcelUrl(taller, seccion);
    
    if (!excelUrl) {
      console.log('❌ No Excel URL found for this taller and section');
      return null;
    }
    
    const response = await axios.get(excelUrl);
    const parsed = Papa.parse(response.data, { header: true, skipEmptyLines: true });
    datosExcelAgenda.value = parsed.data;
    
    return parsed.data;
  } catch (error) {
    console.error('❌ Error al obtener datos del Excel:', error);
    return null;
  }
};

// Optimizar onMounted con lazy loading
onMounted(async () => {
  if (esTallerExcel.value) {
    // Cargar datos del Excel de forma asíncrona
    fetchGoogleSheetAgenda();
  }
  
  // Limpiar cache de memoización después de un tiempo
  setTimeout(() => {
    memoizedValues.clear();
  }, 30000); // 30 segundos
});

// Función específica para formatear fechas de Strapi (ISO UTC)
const formatearFechaStrapi = (fechaISO) => {
  if (!fechaISO) {
    console.log('❌ FECHA VACÍA:', fechaISO);
    return { fecha: '', hora: '' };
  }
  
  try {
    console.log('🔍 PROCESANDO FECHA STRAPI:', fechaISO);
    
    // Parsear la fecha ISO de Strapi y convertir a zona horaria de Argentina
    const fechaClase = moment.tz(fechaISO, 'UTC').tz('America/Argentina/Buenos_Aires');
    
    // Arrays para formateo en español
    const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    
    // Extraer componentes de la fecha
    const diaSemana = dias[fechaClase.day()];
    const dia = String(fechaClase.date()).padStart(2, '0');
    const mes = meses[fechaClase.month()];
    const hora = fechaClase.format('HH');
    
    // Formatear fecha y hora (sin año)
    const fechaFormateada = `${diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)} ${dia} de ${mes}`;
    const horaFormateada = `${hora}HS (ARG)`;
    
    console.log('✅ RESULTADO FORMATEO STRAPI:', {
      fechaOriginal: fechaISO,
      fechaClase: fechaClase.format(),
      diaSemana: diaSemana,
      dia: dia,
      mes: mes,
      hora: hora,
      resultado: { fecha: fechaFormateada, hora: horaFormateada }
    });
    
    return {
      fecha: fechaFormateada,
      hora: horaFormateada
    };
  } catch (error) {
    console.error('❌ Error formateando fecha de Strapi:', error, fechaISO);
    return { fecha: 'Fecha no disponible', hora: '' };
  }
};

// Función optimizada para formatear fecha de clase (con lógica de Excel y Strapi)
const formatearFechaClase = (fecha) => {
  if (!fecha) {
    console.log('❌ FECHA VACÍA EN formatearFechaClase:', fecha);
    return { fecha: '', hora: '' };
  }

  console.log('🔍 formatearFechaClase llamada con:', {
    fecha: fecha,
    origenAgenda: origenAgenda.value,
    propsClasesLength: props.clases?.length,
    esTallerExcel: esTallerExcel.value,
    tallerPath: tallerPath.value,
    datosExcelDisponibles: datosExcelAgenda.value?.length > 0
  });

  // Si la agenda viene de Excel
  if (origenAgenda.value === 'excel') {
    console.log('📊 Procesando fecha de Excel');
    const fechaLimpia = fecha.toLowerCase().replace(/^[^,]+, /, '');
    const fechaClase = moment(fechaLimpia, 'D [de] MMMM [de] YYYY', 'es');
    if (datosExcelAgenda.value?.[0]?.HORA) {
      const [horas, minutos] = datosExcelAgenda.value[0].HORA.split(':');
      fechaClase.hours(parseInt(horas, 10));
      fechaClase.minutes(parseInt(minutos, 10));
    }
    const dias = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
    const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];
    const diaSemana = dias[fechaClase.day()];
    const dia = String(fechaClase.date()).padStart(2, '0');
    const mes = meses[fechaClase.month()];
    const hora = fechaClase.format('HH');
    const resultado = {
      fecha: `${diaSemana} ${dia} DE ${mes}`,
      hora: `${hora}HS (ARG)`
    };
    console.log('✅ Resultado Excel:', resultado);
    return resultado;
  }
  
  // Si la agenda viene de Strapi (por defecto)
  console.log('📊 Procesando fecha de Strapi');
  return formatearFechaStrapi(fecha);
};

</script>
<style scoped>
@media (max-width: 768px) {
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
}

.p-3,
.sm\:p-4 {
  padding: 1.25rem !important;
}

h1,
h2,
h3,
h4 {
  font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
}

@media (max-width: 640px) {

  h1,
  h2,
  h4 {
    font-size: 1.3rem;
  }

  .text-2xl {
    font-size: 1.3rem !important;
  }

  h3,
  .text-xs,
  .md\:text-sm {
    font-size: 0.95rem !important;
  }
}

img.aspect-video {
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}

.shadow-lg {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.13) !important;
}

.rounded-lg {
  border-radius: 0.75rem !important;
}

@media (max-width: 768px) {

  .flex-col,
  .md\:flex-row-reverse {
    flex-direction: column !important;
  }

  .w-full,
  .md\:w-1\/2 {
    width: 100% !important;
  }

  .gap-4,
  .sm\:gap-6 {
    gap: 1.25rem !important;
  }
}

.font-inter {
  font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
}
</style>
